"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactI18next = require("react-i18next");

var _classnames = _interopRequireDefault(require("classnames"));

var _formik = require("formik");

var _reactStripeJs = require("@stripe/react-stripe-js");

var _CircularProgress = _interopRequireDefault(require("@material-ui/core/CircularProgress"));

var _Button = _interopRequireDefault(require("../Button"));

var _StripeFields = _interopRequireDefault(require("./StripeFields"));

var _utils = require("./utils");

var PaymentModal = function PaymentModal(_ref) {
  var stripe = _ref.stripe,
      isNew = _ref.isNew,
      plan = _ref.plan,
      _onSubmit = _ref.onSubmit,
      onCancel = _ref.onCancel,
      isLoading = _ref.isLoading;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  var fieldOrder = ['name', 'cardNumber', 'cvc', 'expiry', 'postalCode'];
  return /*#__PURE__*/_react["default"].createElement(_reactStripeJs.Elements, {
    stripe: stripe
  }, /*#__PURE__*/_react["default"].createElement(_reactStripeJs.ElementsConsumer, null, function (_ref2) {
    var elements = _ref2.elements,
        stripe = _ref2.stripe;
    return /*#__PURE__*/_react["default"].createElement(_formik.Formik, {
      validationSchema: _utils.validationSchema,
      initialValues: {
        name: '',
        postalCode: ''
      },
      onSubmit: function onSubmit(_ref3) {
        var name = _ref3.name,
            postalCode = _ref3.postalCode;
        var cardElement = elements.getElement(_reactStripeJs.CardNumberElement);

        _onSubmit({
          stripe: stripe,
          cardElement: cardElement,
          name: name,
          postalCode: postalCode
        });
      }
    }, function (_ref4) {
      var errors = _ref4.errors,
          touched = _ref4.touched,
          isValid = _ref4.isValid;
      return /*#__PURE__*/_react["default"].createElement(_formik.Form, {
        className: "container p-8 w-full"
      }, isLoading && /*#__PURE__*/_react["default"].createElement("div", {
        className: "absolute h-full w-full flex items-center justify-center -m-8"
      }, /*#__PURE__*/_react["default"].createElement(_CircularProgress["default"], null)), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'opacity-0': isLoading
        })
      }, /*#__PURE__*/_react["default"].createElement("h1", {
        className: "text-2xl font-bold text-center mb-8 text-dark"
      }, isNew ? t('premium.payment.purchase.header') : t('premium.payment.update.header')), !!plan && /*#__PURE__*/_react["default"].createElement("p", {
        className: "my-5"
      }, /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
        i18nKey: "premium.payment.info",
        values: plan
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "font-bold"
      }))), /*#__PURE__*/_react["default"].createElement(_StripeFields["default"], {
        errors: errors,
        touched: touched,
        fieldOrder: fieldOrder
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex"
      }, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        type: "button",
        onClick: onCancel,
        color: "secondary",
        className: "w-1/2 mt-8 mr-3"
      }, t('button.cancel')), /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        type: "submit",
        className: "w-1/2 mt-8 ml-3",
        disabled: !isValid || isLoading
      }, t('button.confirm')))));
    });
  }));
};

var _default = PaymentModal;
exports["default"] = _default;
//# sourceMappingURL=PaymentModal.js.map